import React, { lazy, Suspense } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
const LoginContainer = lazy(() => import('./containers/auth/Login'))
const ForgotPasswordContainer = lazy(() => import('./containers/auth/ForgotPassword'))
const PasswordResetContainer = lazy(() => import('./containers/auth/PasswordReset'))
const EasyGrader = lazy(() => import('./containers/easygrader/EasyGrader'))
import STORE from './store'

export default function Routes() {
  return (
    <Router>
      <Suspense fallback={null}>
        <Switch>
          <Route exact path="/">
            <LoginContainer />
          </Route>
          <Route path="/:district?/:school?/login/:source?">
            <LoginContainer />
          </Route>
          <Route path="/:district?/:school?/forgotpassword">
            <ForgotPasswordContainer />
          </Route>
          <Route path="/:district?/:school?/passwordreset">
            <PasswordResetContainer />
          </Route>
          <Route path="/:district?/:school?/easygradermodule">
            <EasyGrader
              remoteDependencies={{
                STORE,
                parent: 'remote',
              }}
            />
          </Route>
        </Switch>
      </Suspense>
    </Router>
  )
}
